export const HOVER_STYLE = {
    cursor: "pointer",
    transition: "all 0.2s",
    _hover: { boxShadow: "lg", transform: "scale(1.02)", zIndex: 1 },
    _active: { transform: "scale(1)" },
};
